import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { BASE_URL, getAxiosConfig } from '../../components/interface/Config';

const apiClient = axios.create({
  baseURL: `${BASE_URL}`,
  headers: getAxiosConfig().headers, // Default headers setup
});

// Dynamic request interceptor to inject fresh headers (including auth tokens) right before dispatching
apiClient.interceptors.request.use(
  (config) => {
    const freshHeaders = getAxiosConfig().headers;
    config.headers = {
      ...config.headers,
      ...freshHeaders,
    } as any;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Method to handle GET requests
export const getRequest = async <T>(url: string, params?: Record<string, any>): Promise<T> => {
  try {
    const config: AxiosRequestConfig = {
      params,
    };
    const response = await apiClient.get<T>(url, config);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch data from ${url}`, error);
    throw error;
  }
};

// Method to handle POST requests
export const postRequest = async <T>(url: string, data: Record<string, any>): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await apiClient.post<T>(url, data);
    return response.data;
  } catch (error) {
    console.error(`Failed to post data to ${url}`, error);
    throw error;
  }
};

// Method to handle PATCH requests
export const patchRequest = async <T>(url: string, data: Record<string, any>): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await apiClient.patch<T>(url, data);
    return response.data;
  } catch (error) {
    console.error(`Failed to patch data to ${url}`, error);
    throw error;
  }
};

// Method to handle DELETE requests
export const deleteRequest = async <T>(url: string, params?: Record<string, any>): Promise<T> => {
  try {
    const config: AxiosRequestConfig = {
      params,
    };
    const response: AxiosResponse<T> = await apiClient.delete<T>(url, config);
    return response.data;
  } catch (error) {
    console.error(`Failed to delete data from ${url}`, error);
    throw error;
  }
};

export default apiClient;
